import { ChangeDetectionStrategy, Component, SimpleChanges, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren, ChangeDetectorRef, OnInit, OnChanges } from '@angular/core';
import { CommonModule, NgClass, CurrencyPipe, DatePipe } from '@angular/common';
import { MaintenanceService } from '../../../../../../techopsv4/services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { AppModalComponent } from '../../../../../../shared/elements/app-modal/app-modal.component';


@Component({
    selector: 'app-proposal-popup',
    templateUrl: './proposal-popup.component.html',
    styleUrl: './proposal-popup.component.css',
    imports: [NgClass, FormsModule, AppModalComponent, CurrencyPipe, DatePipe]
})
export class ProposalPopupComponent implements OnChanges, OnInit {

  @Input() selectedOption : any;

  @Input() selectedRequestId: any;
  @Input() closedProposalPopup: boolean = false;
  @Input() propDataSource: any;
  @Output('reloadDataEvent') reloadDataEvent = new EventEmitter<any>();

  @ViewChild('modalRoot') modalRoot: any; 
  @ViewChild('cancelOpenRequest') cancelOpenRequest;
  @Output('hidePopup') hidePopup = new EventEmitter<any>();
  selectedReq: any = {};
  fundingOwnerLeaders: string[] = [];
  postProposalOt:any;
  showPropOnDelete: boolean = true;
  previousSelectedReq: any;
  rejectButtonDisabled: boolean = true;
  appJustificationText: string = '';
  justification2Text: string = '';
  proposalOT: any;
  comment: string;
  isInValidData: boolean;

  constructor(
    private maintenanceService: MaintenanceService,
    public toaster: ToastrService,
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef
  ){
      
  }

  ngOnInit() {
    if(this.selectedRequestId && this.selectedRequestId !== '') {
      this.previousSelectedReq = this.selectedRequestId;
     }

  }


  ngOnChanges(changes: SimpleChanges) {
     if(this.selectedRequestId && this.selectedRequestId !== this.previousSelectedReq) {
      this.previousSelectedReq = this.selectedRequestId;
      this.getPropDetails();
     }
      if(this.closedProposalPopup) {
        this.closePropPopup();
        this.closedProposalPopup = false;
      }
  
  }

  getPropDetails(){
    this.maintenanceService.getCdProposalDetails(this.selectedRequestId).subscribe(
      (response: any) => {
        this.selectedReq = {...response};
        this.fundingOwnerLeaders = this.parseFundingOwnerLeaders(this.selectedReq?.Funding_Owner);
        this.proposalOT = this.selectedReq.Proposed_OT_Labor;
        this.postProposalOt = this.calculateProposalOt(this.selectedReq,'Initial');
        this.cdr.detectChanges(); // Trigger change detection to update the view
      },
      (error: any) => {
        console.error('Error fetching request details:', error);
        this.toaster.error('Error fetching request details', '', { timeOut: 5000, positionClass: 'toast-top-center' });
        // this.hidePopup.emit(error);
      }
    );
  }

  private parseFundingOwnerLeaders(raw: unknown): string[] {
    if (typeof raw !== 'string') {
      return [];
    }

    return raw
      .split('#')
      .map((value) => value.trim())
      .filter((value) => value.length > 0);
  }

  calculatePostProposalOt(data:any,state:String) {
    this.postProposalOt = this.calculateProposalOt(data,state);
  }

  calculateProposalOt(data:any,state:String) {
    if (!data || !data.Request_Id) {
      return 0;
    }
    data.Optum_Tech_Labour = data.Optum_Tech_Labour? data.Optum_Tech_Labour : 0;
    data.totalOT = data.totalOT? data.totalOT : 0;
    data.preProposed_OT_Labor = data.preProposed_OT_Labor? Number(data.preProposed_OT_Labor) : 0;
    let proposalOTLabor =  (state == 'Initial')? data.Proposed_OT_Labor : Number(this.proposalOT);
    let postProposalOt = 0;
    let remainingOt = data.Optum_Tech_Labour - data.totalOT;
    if(data && data.Request_Id.includes('A')) {
      // Calculate the total OT for the proposal
      postProposalOt = remainingOt - proposalOTLabor ;
      }
    else if(data && data.Request_Id.includes('U')) {
      // Calculate the total OT for the proposal
     postProposalOt = (data.preProposed_OT_Labor + remainingOt)- proposalOTLabor;

    }
    else if(data && data.Request_Id.includes('DD')) {
      this.showPropOnDelete = false;
      postProposalOt = data.preProposed_OT_Labor + remainingOt ;
    }
    return postProposalOt;

  }



  enableRejectButton(stage: any) {

    switch (stage) {
      case 'AppJust':
        if(this.appJustificationText?.trim() != '')
          this.rejectButtonDisabled = false;
        else 
          this.rejectButtonDisabled = true;
        break;
      case 'ReqJust2':
        if(this.justification2Text?.trim() != '')
          this.rejectButtonDisabled = false;
        else 
          this.rejectButtonDisabled = true;
        break;
      default:
        
    }
  }  

  
onUpdateClick() {
 
    // Call the API with the ID and status
    this.applyJustification();
  }
 
applyJustification() {
 let payload = { 
    "type": 2, 
    "justification":this.justification2Text,
    "userType": 'User', 
    "otLabor":  this.proposalOT
  } 
 
  this.maintenanceService.reqJustification2(payload, this.selectedReq.Request_Id).subscribe( //TODO error on API side?
    (response) => {
      // Handle the response from the API
      if (response && response.message === "Justification updated successfully") {
        this.toaster.success('Request updated successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
        this.reloadDataEvent.emit();
        this.hidePopup.emit(response);
        this.getPropDetails();
        this.rejectButtonDisabled = true;
        this.justification2Text = '';
      }
    },
    (error) => {
      // Handle error response
      this.toaster.error('Error occurred while updating request', '', { timeOut: 5000, positionClass: 'toast-top-center' });
    }
  );
 
 
}

onApproveClick() {

  // Call the API with the ID and status
  this.applyApprovalJustification();
}

applyApprovalJustification() {
let payload = {
  "requestId": this.selectedReq.Request_Id, 
  "status":"Approved", 
  "justification": this.appJustificationText,
} 

this.maintenanceService.proposalUpdatePOST(payload).subscribe( 
  (response) => {
    // Handle the response from the API
    if (response && response.message === "Proposal status updated successfully" ) {
      this.toaster.success('Request approved successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      this.reloadDataEvent.emit();
      this.hidePopup.emit(response);
      this.getPropDetails();
      this.rejectButtonDisabled = true;
      this.appJustificationText = ''; // Clear the justification text after approval
        }
  },
  (error) => {
    // Handle error response
    this.toaster.error('Error occurred while approving request', '', { timeOut: 5000, positionClass: 'toast-top-center' });
  }
);


}

onRejectClick() {
console.log("made it to reject")
  // Call the API with the ID and status
  this.applyRejectJustification();
}

applyRejectJustification() {
console.log(this.selectedReq, 'selectedReq in applyRejectJustification');
let payload = {
  "requestId": this.selectedReq.Request_Id, 
  "status":"Rejected", 
  "justification": this.appJustificationText
} 

this.maintenanceService.proposalUpdatePOST(payload).subscribe( 
  (response) => {
    // Handle the response from the API
    if (response.message === "Proposal status updated successfully") {
      this.toaster.success('Request rejected successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      this.appJustificationText= ''; // Clear the justification text after rejection
      this.reloadDataEvent.emit();
      this.hidePopup.emit(response);
      this.getPropDetails();
      this.rejectButtonDisabled = true;
      if(this.justification2Text !== '' || this.appJustificationText !== '') {
        this.justification2Text = '';
        this.appJustificationText = '';
      }
    }
  },
  (error) => {
    // Handle error response
    console.error('Error occurred while rejecting request:', error);
    this.toaster.error('Error occurred while rejecting request', '', { timeOut: 5000, positionClass: 'toast-top-center' });
  }
);


}

onReqDetailClick() {
 
  // Call the API with the ID and status
  this.applyReqDetailJustification();
}

applyReqDetailJustification() {
let payload = { 
  "type": 1, 
  "justification":this.appJustificationText,
  "userType": 'Approver', 
  "otLabor": this.selectedReq.proposed_OT_Labor
} 

this.maintenanceService.reqJustification2(payload, this.selectedReq.Request_Id).subscribe( //TODO error on API side?
  (response) => {
    // Handle the response from the API
    if (response && response.message === "Justification updated successfully") {
      this.toaster.success('Requested details successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      this.reloadDataEvent.emit();
      this.hidePopup.emit(response);
      this.getPropDetails();
      this.rejectButtonDisabled = true;
      if(this.justification2Text !== '' || this.appJustificationText !== '') {
        this.justification2Text = '';
        this.appJustificationText = '';
      }
    }
  },
  (error) => {
    // Handle error response
    console.error('Error occurred while requesting details:', error);
    this.toaster.error('Error occurred while requesting details', '', { timeOut: 5000, positionClass: 'toast-top-center' });
  }
);
}



onCancelClick() {
  this.cancelOpenRequest.show(); // Show the modal
}

confirmCancel() {
  if (this.selectedReq) {
      const payload = {
        "requestId": this.selectedReq.Request_Id,
          "status": 'Cancelled',
          "justification": this.comment
      };

      console.log('Payload for cancellation:', payload);

      this.maintenanceService.proposalStatusUpdate(payload).subscribe(
          (response) => {
              if (response && response.message === "Proposal status updated successfully") {
                  this.toaster.success('Request cancelled successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
                  this.reloadDataEvent.emit();
                  this.hidePopup.emit(response);
                  this.appJustificationText = '';
                  this.cancelOpenRequest.hide();
                  this.getPropDetails();
                  this.comment = ''; // Clear the comment after cancellation
                  this.rejectButtonDisabled = true;

              } else {
                  this.toaster.error('Failed to cancel request', '', { timeOut: 5000, positionClass: 'toast-top-center' });
              }
          },
          (error) => {
              this.toaster.error('Error occurred while cancelling request', '', { timeOut: 5000, positionClass: 'toast-top-center' });
          }
      );
  }
  this.cancelOpenRequest.hide(); // Close the modal
}


closeCancelModal(){
  this.comment = '';

}

closePropPopup() {
  this.rejectButtonDisabled = true;
  if(this.justification2Text !== '' || this.appJustificationText !== '') {
    this.justification2Text = '';
    this.appJustificationText = '';
  }
  this.proposalOT = this.selectedReq.Proposed_OT_Labor;
}


fieldValueChange(){
  if(this.comment !== '') {
    this.isInValidData = true;
  } else this.isInValidData = false;

}

validateIntegerInput(event: KeyboardEvent) {
  const charCode = event.charCode;
  let allowNegative = false;
  if(this.selectedReq?.Optum_Tech_Labour<0){
    allowNegative = true;
  }else{
    allowNegative = false;
  }
  //if not a valid int (not counting negative sign) dont let it be typed
  if ((charCode < 48 && charCode !=45) || charCode > 57 || (allowNegative == false && charCode == 45)) { // Only allow digits (0-9) and - if remainingOTL is -
    event.preventDefault();
  }
}

}
